<template>
  <div class="message" :class="[isInsufficient ? 'is-warning' : 'is-danger']">
    <div class="message-header">{{ this.headerText }}</div>
    <div class="message-body">
      <p>{{ this.messageText }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "NoPermissionMessage",
  props: {
    isInsufficient: { type: Boolean, default: false },
    title: { type: String, default: '' },
    message: { type: String, default: '' },
    missingPermissions: { type: String, default: '' }
  },
  beforeMount() {
    let insufficientText = "You don't have all neccessary permissions to use this page.\n"
    if (this.missingPermissions) {
      insufficientText += `Please contact your administrator to grant you following permissions: ${this.missingPermissions}`
    }
    this.headerText = this.title || (this.isInsufficient ? 'Insufficient Permissions' : 'Access Denied');
    this.messageText = this.message || (this.isInsufficient ? insufficientText : "You don't have a permission to view this page");
  },
  data() {
    return {
      headerText: '',
      messageText: ''
    }
  }
}
</script>